import { render, staticRenderFns } from "./TableTopScrollbar.vue?vue&type=template&id=f2ded19e&"
import script from "./TableTopScrollbar.vue?vue&type=script&lang=ts&"
export * from "./TableTopScrollbar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports